module.exports = __webpack_public_path__ + "img/order_delivery_smoke.4e1fc2f2.png";